module.exports = __webpack_public_path__ + "img/2012-12-14 18.18.41.7479c95b.jpg";